(function() {
  'use strict';

  // Storage keys
  const INSTALLED_KEY = 'pwa_installed_permanent';
  const LAST_SHOWN_KEY = 'pwa_banner_last_shown_date';

  // How often to show the banner (in days)
  const SHOW_FREQUENCY_DAYS = 7;

  // Elements
  const banner = document.getElementById('smartAppBanner');
  const bannerClose = document.getElementById('bannerClose');
  const bannerAction = document.getElementById('bannerAction');
  const iosModal = document.getElementById('iosModal');
  const iosModalClose = document.getElementById('iosModalClose');
  const successToast = document.getElementById('successToast');
  
  let deferredPrompt;
  let isSafari = false;

  console.log('[Smart Banner] Script initialized');

  // ─── NEW: Detect if the user is on a desktop (not mobile/tablet) ───────────
  function isDesktop() {
    const ua = navigator.userAgent.toLowerCase();

    // True mobile/tablet signals
    const hasTouchUA = /iphone|ipad|ipod|android|blackberry|windows phone|opera mini|silk|mobile/i.test(ua);

    // Touch hardware: tablets often report maxTouchPoints > 0
    const hasTouch = navigator.maxTouchPoints > 0;

    // Screen width: treat anything wider than 1024px WITHOUT touch UA as desktop
    const isWideScreen = window.screen.width > 1024;

    // A device is desktop if it has no mobile UA signals AND is wide AND has no touch points
    const desktop = !hasTouchUA && isWideScreen && !hasTouch;

    console.log('[Smart Banner] Desktop check:', { hasTouchUA, hasTouch, isWideScreen, desktop });
    return desktop;
  }
  // ──────────────────────────────────────────────────────────────────────────

  // Detect browser
  function detectBrowser() {
    const ua = navigator.userAgent.toLowerCase();
    const isSafariUA = /safari/.test(ua) && !/chrome/.test(ua) && !/crios/.test(ua) && !/fxios/.test(ua);
    const isIOS = /iphone|ipad|ipod/.test(ua);
    const isMac = /mac os x/.test(ua);
    
    isSafari = isSafariUA || isIOS;
    
    console.log('[Smart Banner] Browser detection:', {
      isSafari,
      isIOS,
      isMac,
      userAgent: ua
    });
    
    return { isSafari, isIOS, isMac };
  }

  // Check if already installed
  function isInstalled() {
    // Check if running as PWA (multiple methods for better detection)
    const isPWAStandalone = window.matchMedia('(display-mode: standalone)').matches;
    const isPWAMinimalUI = window.matchMedia('(display-mode: minimal-ui)').matches;
    const isPWAFullscreen = window.matchMedia('(display-mode: fullscreen)').matches;
    const isiOSPWA = window.navigator.standalone === true;
    
    const isPWA = isPWAStandalone || isPWAMinimalUI || isPWAFullscreen || isiOSPWA;
    
    // Check permanent storage (user clicked install)
    const wasInstalled = localStorage.getItem(INSTALLED_KEY) === 'true';
    
    console.log('[Smart Banner] Installation check:', { 
      isPWAStandalone, 
      isPWAMinimalUI, 
      isPWAFullscreen, 
      isiOSPWA, 
      wasInstalled,
      finalResult: isPWA || wasInstalled
    });
    
    return isPWA || wasInstalled;
  }

  // ─── UPDATED: Check if banner was shown within the last SHOW_FREQUENCY_DAYS ─
  function wasShownRecently() {
    const lastShown = localStorage.getItem(LAST_SHOWN_KEY);
    if (!lastShown) return false;

    const lastShownDate = new Date(lastShown);
    const now = new Date();
    const msSinceShown = now - lastShownDate;
    const daysSinceShown = msSinceShown / (1000 * 60 * 60 * 24);

    console.log('[Smart Banner] Frequency check:', {
      lastShown: lastShownDate.toISOString(),
      now: now.toISOString(),
      daysSinceShown: daysSinceShown.toFixed(2),
      frequencyDays: SHOW_FREQUENCY_DAYS,
      shouldSuppress: daysSinceShown < SHOW_FREQUENCY_DAYS
    });

    return daysSinceShown < SHOW_FREQUENCY_DAYS;
  }
  // ──────────────────────────────────────────────────────────────────────────

  // Mark banner as shown now
  function markShownNow() {
    const now = new Date().toISOString();
    localStorage.setItem(LAST_SHOWN_KEY, now);
    console.log('[Smart Banner] Marked as shown at:', now);
  }

  // Mark as installed permanently
  function markInstalled() {
    localStorage.setItem(INSTALLED_KEY, 'true');
    console.log('[Smart Banner] Marked as permanently installed');
  }

  // Check if app was uninstalled
  function wasUninstalled() {
    const wasInstalled = localStorage.getItem(INSTALLED_KEY) === 'true';
    
    // Check if running as PWA (multiple methods)
    const isPWAStandalone = window.matchMedia('(display-mode: standalone)').matches;
    const isPWAMinimalUI = window.matchMedia('(display-mode: minimal-ui)').matches;
    const isPWAFullscreen = window.matchMedia('(display-mode: fullscreen)').matches;
    const isiOSPWA = window.navigator.standalone === true;
    const isPWA = isPWAStandalone || isPWAMinimalUI || isPWAFullscreen || isiOSPWA;
    
    if (isPWA && wasInstalled) {
      return false;
    }
    
    console.log('[Smart Banner] Install status check:', { wasInstalled, isPWA });
    return false;
  }

  // Show banner
  function showBanner() {
    if (!banner) return;
    
    console.log('[Smart Banner] Showing banner');
    
    // Mark as shown now so it won't appear again for SHOW_FREQUENCY_DAYS days
    markShownNow();
    
    setTimeout(() => {
      banner.classList.add('show');
      document.body.classList.add('smart-banner-active');
    }, (window.SM_PWA_DELAY || 1) * 1000);
  }

  // Hide banner
  function hideBanner() {
    if (banner) {
      banner.classList.remove('show');
      document.body.classList.remove('smart-banner-active');
    }
  }

  // Show iOS modal
  function showIOSModal() {
    if (iosModal) {
      console.log('[Smart Banner] Showing iOS instructions');
      iosModal.classList.add('show');
      document.body.style.overflow = 'hidden';
      
      const ua = navigator.userAgent.toLowerCase();
      const isMac = /mac os x/.test(ua);
      const isIOS = /iphone|ipad|ipod/.test(ua);
      
      const desktopNote = document.getElementById('iosDesktopNote');
      if (desktopNote && isMac && !isIOS) {
        desktopNote.style.display = 'block';
        console.log('[Smart Banner] Desktop Safari detected - showing mobile-only note');
      }
    }
  }

  // Hide iOS modal
  function hideIOSModal() {
    if (iosModal) {
      iosModal.classList.remove('show');
      document.body.style.overflow = '';
    }
  }

  // Show Android modal
  function showAndroidModal() {
    const androidModal = document.getElementById('androidModal');
    if (androidModal) {
      console.log('[Smart Banner] Showing Android modal');
      androidModal.classList.add('show');
      document.body.style.overflow = 'hidden';
    }
  }

  // Hide Android modal
  function hideAndroidModal() {
    const androidModal = document.getElementById('androidModal');
    if (androidModal) {
      androidModal.classList.remove('show');
      document.body.style.overflow = '';
    }
  }

  // Show install toasts: "Installing..." first, success ~6s later
  // (the home-screen icon takes a few seconds to appear after Chrome's prompt)
  let toastSequenceStarted = false;
  function showSuccessToast() {
    if (!successToast || toastSequenceStarted) return;
    toastSequenceStarted = true;

    console.log('[Smart Banner] Showing install toast sequence');
    const toastText = document.getElementById('successToastText');
    const toastIcon = successToast.querySelector('svg');

    if (toastText) toastText.textContent = '\u23f3 Installing your app\u2026';
    if (toastIcon) toastIcon.style.display = 'none';
    successToast.classList.add('show');

    setTimeout(() => {
      if (toastText) toastText.textContent = 'App installed! Find SALWAR MAHAL on your home screen.';
      if (toastIcon) toastIcon.style.display = '';
      successToast.classList.remove('show');
      void successToast.offsetWidth;
      successToast.classList.add('show');

      setTimeout(() => {
        successToast.classList.remove('show');
      }, 5000);
    }, 6000);
  }

  // Handle banner action button click
  if (bannerAction) {
    bannerAction.addEventListener('click', async () => {
      console.log('[Smart Banner] Action button clicked');
      
      if (isSafari) {
        showIOSModal();
        
        if (typeof gtag !== 'undefined') {
          gtag('event', 'pwa_ios_instructions_shown');
        }
      } else if (deferredPrompt) {
        // One-tap install (PWA Phase 1): fire the native rich install sheet directly
        console.log('[Smart Banner] Firing native install prompt');
        deferredPrompt.prompt();
        const { outcome } = await deferredPrompt.userChoice;
        console.log('[Smart Banner] User choice:', outcome);
        if (outcome === 'accepted') {
          markInstalled();
          hideBanner();
          showSuccessToast();
          if (typeof gtag !== 'undefined') {
            gtag('event', 'pwa_install', { method: 'banner_one_tap' });
          }
        }
        deferredPrompt = null;
        
        if (typeof gtag !== 'undefined') {
          gtag('event', 'pwa_native_prompt_shown');
        }
      } else {
        console.log('[Smart Banner] No install prompt available - showing manual instructions');
        showAndroidModal();
        
        if (typeof gtag !== 'undefined') {
          gtag('event', 'pwa_install_fallback_shown');
        }
      }
    });
  }

  // Close banner
  if (bannerClose) {
    bannerClose.addEventListener('click', () => {
      console.log('[Smart Banner] Close button clicked');
      hideBanner();
      
      if (typeof gtag !== 'undefined') {
        gtag('event', 'pwa_banner_dismissed', { method: 'close_button' });
      }
    });
  }

  // "I already have the app" — permanently suppress the banner in this browser
  const bannerAlreadyHave = document.getElementById('bannerAlreadyHave');
  if (bannerAlreadyHave) {
    bannerAlreadyHave.addEventListener('click', (e) => {
      e.stopPropagation();
      markInstalled();
      hideBanner();
      if (typeof gtag !== 'undefined') {
        gtag('event', 'pwa_banner_dismissed', { method: 'already_have' });
      }
    });
  }

  // Close iOS modal
  if (iosModalClose) {
    iosModalClose.addEventListener('click', () => {
      console.log('[Smart Banner] iOS modal close clicked');
      hideIOSModal();
    });
  }

  // Close iOS modal when clicking outside
  if (iosModal) {
    iosModal.addEventListener('click', (e) => {
      if (e.target === iosModal) {
        hideIOSModal();
      }
    });
  }

  // Android modal - Close button
  const androidModalClose = document.getElementById('androidModalClose');
  if (androidModalClose) {
    androidModalClose.addEventListener('click', () => {
      console.log('[Smart Banner] Android modal close clicked');
      hideAndroidModal();
    });
  }

  // Android modal - Install Now button
  const androidInstallButton = document.getElementById('androidInstallButton');
  if (androidInstallButton) {
    androidInstallButton.addEventListener('click', async () => {
      console.log('[Smart Banner] Install Now clicked');
      
      if (deferredPrompt) {
        hideAndroidModal();
        
        deferredPrompt.prompt();
        
        const { outcome } = await deferredPrompt.userChoice;
        console.log(`[Smart Banner] User choice: ${outcome}`);
        
        if (outcome === 'accepted') {
          console.log('[Smart Banner] User accepted installation');
          markInstalled();
          hideBanner();
          showSuccessToast();
          
          if (typeof gtag !== 'undefined') {
            gtag('event', 'pwa_install', { method: 'android_modal' });
          }
        }
        
        deferredPrompt = null;
      } else {
        // No native prompt available: reveal manual install steps (PWA Phase 1)
        var steps = document.getElementById('androidManualSteps');
        if (steps) steps.style.display = 'block';
      }
    });
  }

  // Android modal - Maybe Later button
  const androidInstallLater = document.getElementById('androidInstallLater');
  if (androidInstallLater) {
    androidInstallLater.addEventListener('click', () => {
      console.log('[Smart Banner] Maybe Later clicked');
      hideAndroidModal();
      
      if (typeof gtag !== 'undefined') {
        gtag('event', 'pwa_install_dismissed', { method: 'maybe_later' });
      }
    });
  }

  // Android modal - Close when clicking outside
  const androidModal = document.getElementById('androidModal');
  if (androidModal) {
    androidModal.addEventListener('click', (e) => {
      if (e.target === androidModal) {
        hideAndroidModal();
      }
    });
  }

  // Listen for beforeinstallprompt event
  window.addEventListener('beforeinstallprompt', (e) => {
    console.log('[Smart Banner] beforeinstallprompt fired');
    e.preventDefault();
    deferredPrompt = e;
  });

  // Track when PWA is installed
  window.addEventListener('appinstalled', () => {
    console.log('[Smart Banner] PWA was installed via appinstalled event');
    markInstalled();
    hideBanner();
    showSuccessToast();

    // Count the install in App Stats Daily; /pages/app has its own beacon, so skip there
    if (location.pathname.indexOf('/pages/app') === -1) {
      try {
        const ua = navigator.userAgent;
        const body = JSON.stringify({
          event: 'installed', source: 'site_banner',
          device: /iPhone|iPod/.test(ua) ? 'iPhone' : (/Android/.test(ua) ? 'Android' : 'Desktop'),
          standalone: false, in_app: false, ts: new Date().toISOString()
        });
        const BEACON = 'https://n8n-shaf-u71178.vm.elestio.app/webhook/app-page-visit';
        if (navigator.sendBeacon) navigator.sendBeacon(BEACON, new Blob([body], { type: 'text/plain' }));
        else fetch(BEACON, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain' }, body: body });
      } catch (e) {}
    }

    if (typeof gtag !== 'undefined') {
      gtag('event', 'pwa_installed', { method: 'browser' });
    }
  });

  // Additional check: If beforeinstallprompt doesn't fire within 3 seconds
  let promptCheckTimeout = setTimeout(() => {
    if (!deferredPrompt && banner && banner.classList.contains('show')) {
      console.log('[Smart Banner] No install prompt available - checking if already installed');
      
      if ('getInstalledRelatedApps' in navigator) {
        navigator.getInstalledRelatedApps().then((relatedApps) => {
          if (relatedApps.length > 0) {
            console.log('[Smart Banner] App detected as installed via getInstalledRelatedApps');
            markInstalled();
            hideBanner();
          }
        }).catch(err => {
          console.log('[Smart Banner] getInstalledRelatedApps check failed:', err);
        });
      }
    }
  }, 3000);

  // Initialize
  function init() {
    console.log('[Smart Banner] Initializing...');
    
    detectBrowser();

    // ─── NEW: Skip entirely on desktop ──────────────────────────────────────
    if (isDesktop()) {
      console.log('[Smart Banner] Desktop detected — banner suppressed');
      return;
    }
    // ────────────────────────────────────────────────────────────────────────

    wasUninstalled();
    
    // Mark as installed if currently running as PWA
    const isPWAStandalone = window.matchMedia('(display-mode: standalone)').matches;
    const isPWAMinimalUI = window.matchMedia('(display-mode: minimal-ui)').matches;
    const isPWAFullscreen = window.matchMedia('(display-mode: fullscreen)').matches;
    const isiOSPWA = window.navigator.standalone === true;
    const currentlyRunningAsPWA = isPWAStandalone || isPWAMinimalUI || isPWAFullscreen || isiOSPWA;
    
    if (currentlyRunningAsPWA) {
      console.log('[Smart Banner] Currently running as PWA - marking as installed');
      markInstalled();
      return;
    }
    
    // Don't show if already installed
    if (isInstalled()) {
      console.log('[Smart Banner] App already installed, not showing banner');
      return;
    }

    // ─── UPDATED: Don't show if shown within the last SHOW_FREQUENCY_DAYS ──
    if (wasShownRecently()) {
      console.log('[Smart Banner] Banner shown within the last ' + SHOW_FREQUENCY_DAYS + ' days, not showing again');
      return;
    }
    // ────────────────────────────────────────────────────────────────────────

    showBanner();
  }

  // Global trigger so menu links can start the install flow (PWA Phase 1)
  window.SMTriggerInstall = function() {
    detectBrowser();
    if (isSafari) {
      showIOSModal();
      if (typeof gtag !== 'undefined') gtag('event', 'pwa_ios_instructions_shown', { method: 'menu_link' });
    } else if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(function(choice) {
        if (choice.outcome === 'accepted') {
          markInstalled();
          hideBanner();
          showSuccessToast();
          if (typeof gtag !== 'undefined') gtag('event', 'pwa_install', { method: 'menu_link' });
        }
        deferredPrompt = null;
      });
    } else {
      showAndroidModal();
      if (typeof gtag !== 'undefined') gtag('event', 'pwa_install_fallback_shown', { method: 'menu_link' });
    }
  };

  // Wait for DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
